import { copyTextToClipboard } from 'shared/lib/copyTextToTextClipboard/copyTextToTextClipboard'

export const sharedLinkCopiedMessage = 'Ссылка скопирована'

const isMobileNavigator = (navigatorImpl) =>
    /Android|iPad|iPhone|iPod/i.test(navigatorImpl?.userAgent || '') ||
    (navigatorImpl?.platform === 'MacIntel' &&
        navigatorImpl?.maxTouchPoints > 1)

export const shareFunc = async (url, navigatorImpl = window.navigator) => {
    const link = typeof url === 'string' ? url : window.location.href

    if (
        isMobileNavigator(navigatorImpl) &&
        typeof navigatorImpl.share === 'function'
    ) {
        try {
            await navigatorImpl.share({ url: link })
            return null
        } catch (error) {
            if (error?.name === 'AbortError') {
                return null
            }
        }
    }

    copyTextToClipboard(link)
    return sharedLinkCopiedMessage
}
